import type { FC } from "react"

import { AttachFilesDialog } from "@/components/upload/AttachFilesDialog/AttachFilesDialog"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import { PURCHASE_ORDER_DOCUMENT_TYPE_OPTIONS } from "@/screens/Procurement/PurchaseOrder/constants"

interface GoodsReceiptFileFormDialogProps {
  onClose: () => void
  onRefresh: () => void
  goodsReceiptId: string
}

export const GoodsReceiptFileFormDialog: FC<GoodsReceiptFileFormDialogProps> = ({
  onClose,
  onRefresh,
  goodsReceiptId,
}) => (
  <AttachFilesDialog
    title='Attach File'
    referenceTableName={ReferenceTableName.AdvancedGoodsReceipt}
    referenceId={goodsReceiptId}
    documentTypeOptions={PURCHASE_ORDER_DOCUMENT_TYPE_OPTIONS}
    successMessage='Files attached'
    testIdPrefix='goods-receipt-file'
    dialogTestId='goods-receipt-file-dialog'
    onClose={onClose}
    onSuccess={onRefresh}
  />
)
